import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { IAssigneeLog } from "../../models/assigneeLog.model";

interface AssigneeLogsProps {
  logs: IAssigneeLog[];
}

const AssigneeLogs: React.FC<AssigneeLogsProps> = ({ logs }) => {
  const userId = useSelector((state: RootState) => state.auth.userId);

  if (!logs || logs.length === 0) {
    return (
      <div className="text-gray-500 text-sm py-4">
        No assignee history available
      </div>
    );
  }

  const formatDate = (date: Date) => {
    return new Date(date).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="mt-6  bg-white rounded-lg ml-2">
      <div className="pb-2 border-b border-gray-200 flex-shrink-0">
        <h2 className="text-base md:text-lg font-bold text-gray-800 flex items-center gap-2">
          <svg
            className="w-5 h-5 text-blue-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
          Assignee Logs
        </h2>
      </div>

      <div className="space-y-3">
        {logs?.map((log) => (
          <div key={log._id} className="p-3 bg-gray-50 rounded-lg text-xs ">
            <div>
              <div>
                <p className="font-medium">
                  Assigned To:{" "}
                  <span className="text-blue-600">
                    {log.newAssignee?.username || "Unassigned"}
                  </span>
                </p>
                <p className="text-gray-500 text-xs mt-1 mb-1">
                  Updated by:{" "}
                  <span
                    className={
                      log.updatedBy?._id === userId
                        ? "text-green-600"
                        : "text-gray-600"
                    }
                  >
                    {log.updatedBy?.username}
                  </span>
                </p>
              </div>
              <div className="text-xs text-gray-500 ">
                {formatDate(log.changedAt)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssigneeLogs;
